// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.skeleton-row[data-v-669eadb4] {\n  width: 100%;\n}\n.skeleton-row[data-v-669eadb4] .v-skeleton-loader__list-item-avatar-two-line,\n.skeleton-row[data-v-669eadb4] .v-skeleton-loader__list-item-two-line {\n  background: transparent;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
